import en from './languages/en';
import de from './languages/de';


const config: CVT.Config = {
  projectName: 'StoryForge',
  featureFlags: {
    googleSSO: true,
    microsoftSSO: false,
    translations: false,
    notifications: false,
    darkMode: false,
  },
  theme: {
    defaultMode: 'light',
    drawerWidth: 240,
    disableRipple: true,
    elevation: 0,
  },
  language: {
    dictionaries: {
      en,
      de,
    },
    languageLabelMap: {
      en: 'English',
      de: 'Deutsche',
    },
    supportedLanguages: ['en', 'de'],
    defaultLanguage: 'en',
    defaultDictionary: en,
  },
  defaultPermissions: {
    users: {
      list: false,
      view: true,
      create: false,
      edit: false,
      delete: false,
      invite: true,
    },
    companies: {
      list: true,
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    stories: {
      list: true,
      view: true,
      create: true,
      edit: true,
      delete: true,
    },
    meetings: {
      list: true,
      view: true,
      create: true,
      edit: true,
      delete: true,
    },
    feedbacks: {
      list: true,
      view: true,
      create: true,
      edit: true,
      delete: true,
    },
    programs: {
      list: true,
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
  },
  dialogs: [
    'inviteTeamMember',
    'editLeadershipValues',
    'editCommunicationObjectives',
    'meetingLinkStories',
    'createMeetingFeedback',
    'editMeetingFeedback',
    'structuralAnalysis',
    'supportCharacter',
  ],
};

export default config;
